import { ContentMetadata } from '@amzn/awscat-pattern-library-service-model';
import React, { useContext } from 'react';
import { Link } from '@amzn/awsui-components-core';
import { convertEntities } from '@amzn/awscat-editor';
import { AppContext } from '../../contexts/AppContext';
import { getContentPath } from '../../common/ContentPaths';

interface Props {
  contentId: string;
  metadata: ContentMetadata;
}

const WorkflowViewerAuthorLink: React.FunctionComponent<Props> = (props: Props) => {
  const { contentId, metadata } = props;
  const appContext = useContext(AppContext);
  return (
    <Link variant="secondary" href={getContentPath({ contentId, mode: 'draft', role: 'author' })}>
      {convertEntities(metadata.contentName, appContext.entities)}
    </Link>
  );
};

export default WorkflowViewerAuthorLink;
